<template>
  <app-launcher-settings
    :s-active="settings"
    :s-initial="settingsInDB"
    :versions="availableVersions"
    :migrations-by-range="migrationsByRange"
    :is-disabled="isSavingSettings"
    :is-saving="isSavingSettings"
    @settings-change="onSettingsChange"
    @save="onSaveAppLauncherSettings"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherSettings from '../components/settings/AppLauncherSettings.vue';
import { useAppLauncher, useCommonActions } from '../composables';

export default defineComponent({
  name: 'AppLauncherSettingsContainer',
  components: { AppLauncherSettings },
  setup() {
    const {
      settings,
      settingsInDB,
      availableVersions,
      migrationsByRange,
      isSavingSettings,
    } = useAppLauncher();
    const { onSettingsChange, onSaveAppLauncherSettings } = useCommonActions();

    return {
      settings,
      settingsInDB,
      availableVersions,
      migrationsByRange,
      isSavingSettings,
      onSettingsChange,
      onSaveAppLauncherSettings,
    };
  },
});
</script>
